import { SET_DATA_REVIEW_LIST } from '../../actions/review';

const initialState = {
    result: null
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_DATA_REVIEW_LIST:
            return { ...state, result: action.payload.items };
        default:
            return state;
    }
}